module.exports = __webpack_public_path__ + "static/media/dusting.f1b9f444.png";